import jarallax from 'jarallax/src/jarallax.esm';

export default function initRegistrationParallax() {
  const banner = document.querySelector('.js-registration-parallax');

  if (!banner) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const compactViewport = window.matchMedia('(max-width: 767px)');

  jarallax(banner, {
    speed: 0.25,
    imgPosition: '50% 50%',
    disableParallax: () => reducedMotion.matches || compactViewport.matches,
  });
}
